@if (displayEnvironmentIndicator) {
  <div class="environmentIndicator">
    {{ environmentIndicatorValue }}
  </div>
}
